/* eslint-disable import/prefer-default-export */
export const DEFAULT_LIMIT = 10;
